export default "__VITE_ASSET__Q1dZ83$j__"